/**
 * O nó `mensagem`: mostra um texto no meio do caminho e não coleta nada.
 *
 * Ele PARA o percurso (`no_para` em `0002_motor.sql` inclui `mensagem`), então
 * seguir é uma chamada a `responder` como qualquer outra — com valor `null`,
 * que o motor não grava porque só grava item de nó do tipo `pergunta`.
 */

import { useEffect, useRef } from 'react';

import type { NoDoConvite } from '../../tipos';
import type { Problema } from '../../ganchos/useConvite';
import { rotuloDoBotao } from './Pergunta';

export type PropsDaMensagem = {
  readonly no: NoDoConvite;
  readonly enviando: boolean;
  readonly problema: Problema | null;
  readonly focar: boolean;
  readonly aoSeguir: () => void;
};

export function Mensagem({ no, enviando, problema, focar, aoSeguir }: PropsDaMensagem) {
  const titulo = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (focar) titulo.current?.focus();
  }, [focar]);

  const corpo = typeof no.config['mensagem'] === 'string' ? (no.config['mensagem'] as string) : '';

  return (
    <section className="mensagem">
      <h2 className="pergunta__rotulo" ref={titulo} tabIndex={-1}>
        {no.rotulo}
      </h2>

      {/* O texto vem de um campo de várias linhas no construtor. `pre-line`
          preserva as quebras que quem escreveu colocou — sem elas, um endereço
          e um horário viram um parágrafo só. */}
      {corpo !== '' ? <p className="texto-do-organizador">{corpo}</p> : null}

      {no.ajuda.trim() !== '' ? <p className="campo__ajuda">{no.ajuda}</p> : null}

      {problema ? (
        <p className="aviso aviso--erro" role="alert">
          <span className="aviso__rotulo">Não enviou</span>
          <span className="aviso__corpo">{problema.mensagem}</span>
        </p>
      ) : null}

      <div className="acoes">
        <button
          className="botao botao--primario"
          type="button"
          aria-busy={enviando}
          disabled={enviando}
          onClick={aoSeguir}
        >
          {rotuloDoBotao(enviando, problema)}
        </button>
      </div>
    </section>
  );
}
